import type { IconSvgObject } from './types';

const ChevronLeftIcon: IconSvgObject = [
  ["path", { d: "M15 18C15 18 9.00001 13.5811 9 12C8.99999 10.4188 15 6 15 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ChevronLeftIcon;
